import { render, staticRenderFns } from "./PickCoursePackage.vue?vue&type=template&id=4266564f&"
import script from "./PickCoursePackage.vue?vue&type=script&lang=js&"
export * from "./PickCoursePackage.vue?vue&type=script&lang=js&"
import style0 from "./PickCoursePackage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports